export default __webpack_public_path__ + "static/media/README.46161a99.md";